module.exports = __webpack_public_path__ + "img/memberships.8566fbfc.svg";